import styled from 'styled-components';
import fundo from '../../../src/assets/img/pattern.png';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: url(${fundo}), #334f7d;
  background-blend-mode: multiply;
  width: 35%;
  background-size: cover;
  box-shadow: -2px 0px 6px 0px rgba(50, 50, 50, 0.51);

  @media (max-width: 800px) {
    padding: 8% 2%;
    width: 100%;
  }
`;

export const Box = styled.div<{ width: string | number; maxwidth: string | number }>`
  background-color: #fff;
  padding: 60px 50px 60px 50px;
  border-radius: 10px;
  border: 1px solid #dfdfdf;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  width: 90%;

  a {
    float: right;
  }

  .ant-image {
    display: block;
    max-width: 335px;
    margin: 0 auto 40px;
  }

  .ant-select {
    width: 100%;
    min-width: 200px;
    margin-bottom: 16px;
  }

  @media (max-width: 600px) {
    border: 0;
    box-shadow: none;
    padding: 6% 4%;
    width: 100%;

    form {
      min-width: 100%;
    }
  }
`;
